'use strict';

import Component from 'generic.basecomponent';
import $ from 'jquery';
import slick from 'slick-carousel';

export default class LogoList extends Component {
    constructor(el) {
        super(el);
        this.$container = $(this.container);
        this.init();
    }

    init() {
        this.$inner = this.$container.find('.js-logo-list-inner');
        this.$arrows = this.$container.find('.js-logo-list-arrows');

        this.$inner.slick({
            appendArrows: this.$arrows,
            infinite: true,
            arrows: true,
            speed: 300,
            autoplay: false,
            slidesToShow: 1,
            variableWidth: true,
            centerMode: true,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: "unslick"
                }
            ],
            prevArrow: `<button type="button" class="logo-list__arrow logo-list__arrow--prev">
                            <svg class="logo-list__arrow-icon">
                                <use xlink:href="#icon-arrow-left"></use>
                            </svg>
                        </button>`,
            nextArrow: `<button type="button" class="logo-list__arrow logo-list__arrow--next">
                            <svg class="logo-list__arrow-icon">
                                <use xlink:href="#icon-arrow-right"></use>
                            </svg>
                        </button>`,
        });
    }
}



// WEBPACK FOOTER //
// ./app/components/logo-list/js/generic.logo-list.js